<!-- <div class="preloader" [hidden]="load">
  <div class="loading">
      <img src="assets/images/loader/loader.svg">
  </div>
</div> -->

<app-loading [hidden]="load"></app-loading>

<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="background-size: cover; background-position: center center;">
  <div class="container">
      <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
              <h1 class="pagetitle__heading mb-10">Vacancy</h1>
          </div>
      </div>
  </div>
</section>

<section class="portfolio-layout3">
  <div class="container">

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-3">
          <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
            <li [ngClass]="{'active2': selectedItem == null}" routerLink="/Vacancy"><a>All</a></li>
              <li *ngFor="let item of arrayVecancyCategory" [ngClass]="{'active2': selectedItem == item.postID}">
                <a style="cursor: pointer;" routerLink="/vacancy/{{item.postID}}">{{item.postTitle}}</a>
              </li>
          </ul>
      </div>
          <div class="row col-sm-12 col-md-12 col-lg-9">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="job-item">
            <div class="job-item__meta">
              <h5 class="job-item__title" style="position: center center">{{vacancyName}}</h5>
          </div>
          <div class="job-item__meta">
            <span class="">{{vacancyDsc}}</span>
          </div>
          <p class="pDetails col-sm-12 col-md-12 col-lg-12" [innerHtml]="vacancyDetails"></p>
</div>
</div>
            </div>
            </div>
            </div>
</section>
